export default __webpack_public_path__ + "static/uk-androidskyline-118e270c0cef9742eef77324c1b8f3a1.webp";